module.exports = __webpack_public_path__ + "img/Monte_Kope_16.7338065e.jpg";